import { useRegisterSW } from 'virtual:pwa-register/react';
import { useSyncStore } from '../../stores/sync.store';
import { useEffect, useState } from 'react';

export function UpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  const isOnline = useSyncStore((s) => s.isOnline);
  const [showOfflineToast, setShowOfflineToast] = useState(false);

  // Trigger toast when connectivity state changes
  useEffect(() => {
    if (!isOnline) {
      setShowOfflineToast(true);
    } else {
      setShowOfflineToast(false);
    }
  }, [isOnline]);

  const closePrompt = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  return (
    <div className="fixed bottom-6 left-6 z-[70] flex flex-col gap-3 max-w-sm pointer-events-none">
      {/* ═══════════ Offline Ready Toast ═══════════ */}
      {offlineReady && (
        <div className="pointer-events-auto flex items-center justify-between gap-4 rounded-xl border border-success/20 bg-surface p-4 shadow-xl shadow-success/5 animate-scale-in">
          <div className="flex gap-2">
            <span className="text-lg">📱</span>
            <div>
              <p className="text-xs font-bold text-text-primary">Aplicación Lista</p>
              <p className="text-[11px] text-text-secondary mt-0.5">La app ya funciona 100% sin conexión a internet.</p>
            </div>
          </div>
          <button
            onClick={closePrompt}
            className="text-text-tertiary hover:text-text-primary text-xs font-semibold px-2 py-1 rounded hover:bg-surface-tertiary"
          >
            Entendido
          </button>
        </div>
      )}

      {/* ═══════════ SW Update Available Prompt ═══════════ */}
      {needRefresh && (
        <div className="pointer-events-auto flex flex-col gap-3 rounded-xl border border-brand-orange/20 bg-surface p-4 shadow-xl shadow-brand-orange/5 animate-scale-in">
          <div className="flex gap-2">
            <span className="text-lg">🚀</span>
            <div>
              <p className="text-xs font-bold text-text-primary">Actualización Disponible</p>
              <p className="text-[11px] text-text-secondary mt-0.5">Una nueva versión de Depilaway está lista.</p>
            </div>
          </div>
          <div className="flex gap-2 justify-end">
            <button
              onClick={closePrompt}
              className="text-text-secondary hover:text-text-primary text-[11px] font-semibold px-3 py-1.5 rounded-lg border border-border hover:bg-surface-tertiary"
            >
              Ignorar
            </button>
            <button
              onClick={() => updateServiceWorker(true)}
              className="bg-brand-orange hover:bg-brand-orange-light text-white text-[11px] font-bold px-3 py-1.5 rounded-lg shadow-sm"
            >
              Actualizar
            </button>
          </div>
        </div>
      )}

      {/* ═══════════ Network Offline Banner ═══════════ */}
      {showOfflineToast && (
        <div className="pointer-events-auto flex items-center justify-between gap-4 rounded-xl border border-error/20 bg-error/5 p-4 shadow-xl shadow-error/5 animate-scale-in backdrop-blur-sm">
          <div className="flex gap-2">
            <span className="text-lg">⚠️</span>
            <div>
              <p className="text-xs font-bold text-error">Modo Fuera de Línea</p>
              <p className="text-[11px] text-error/95 mt-0.5">Operando localmente. Los cambios se sincronizarán al volver a conectar.</p>
            </div>
          </div>
          <button
            onClick={() => setShowOfflineToast(false)}
            className="text-error hover:text-error-dark text-xs font-bold px-2 py-1 rounded hover:bg-error/10"
          >
            Ocultar
          </button>
        </div>
      )}
    </div>
  );
}
